import { useCallback, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './dialogue-box.module.css';

interface TermHighlightProps {
  term: string;
  definition?: string;
}

export function TermHighlight({ term, definition }: TermHighlightProps) {
  const anchorRef = useRef<HTMLSpanElement>(null);
  const [popover, setPopover] = useState<{ left: number; top: number } | null>(null);

  const showPopover = useCallback(() => {
    if (!definition) return;
    const rect = anchorRef.current?.getBoundingClientRect();
    if (!rect) return;
    setPopover({
      left: rect.left + rect.width / 2,
      top: rect.top,
    });
  }, [definition]);

  const hidePopover = useCallback(() => {
    setPopover(null);
  }, []);

  return (
    <>
      <span
        ref={anchorRef}
        className={definition ? styles.termHighlight : styles.termHighlightOnly}
        tabIndex={definition ? 0 : undefined}
        onClick={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
        onPointerDown={(event) => event.stopPropagation()}
        onMouseEnter={showPopover}
        onMouseLeave={hidePopover}
        onFocus={showPopover}
        onBlur={hidePopover}
      >
        {term}
      </span>
      {definition &&
        popover &&
        typeof document !== 'undefined' &&
        createPortal(
          <span
            className={styles.termPopoverFixed}
            role="tooltip"
            style={{
              left: popover.left,
              top: popover.top,
              transform: 'translate(-50%, calc(-100% - 8px))',
            }}
          >
            {definition}
          </span>,
          document.body
        )}
    </>
  );
}
